import React, { useEffect, useState } from 'react';
import { Table, TableSum, TableHeader, TableHeaderSum, TableHeaderSumForJM, TableRow, TitleCell } from './FansCount.style';
import MainLayout from '../../components/Layouts/Main/MainLayout.index';
import { getWebUserSchedule, getOshicalAndJankatsumasterUserCnt } from "../../api/project";
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';

function FansCount() {
    const [infoList, setInfoList] = useState([]);
    const [filterUserName, setFilterUserName] = useState('');
    const [filterUserId, setFilterUserId] = useState('');
    const [filterUpdateAt, setFilterUpdateAt] = useState('');
    const [filterMaxScheduleDate, setFilterMaxScheduleDate] = useState('');
    //const [searchMode, setSearchMode] = useState<'and' | 'or'>('and');
    const [searchMode, setSearchMode] = useState('and');
    const [sortColumn, setSortColumn] = useState('');
    //const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
    const [sortDirection, setSortDirection] = useState('asc');

    const [oshicalUserCnt, setOshicalUserCnt] = useState('');
    const [jKMUserProCnt, setJKMUserProCnt] = useState('');
    const [jKMUserFansCnt, setJKMUserFansCnt] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const userId = sessionStorage.getItem('userId');
        if (!userId) {
            navigate('/');
            return;
        }
        const getInfos = async () => {
            try {
                const res1 = await getOshicalAndJankatsumasterUserCnt();
                if (res1.code === 200) {
                    const sumInfo = res1.data;
                    setOshicalUserCnt(sumInfo.oshicalUserCnt);
                    setJKMUserProCnt(sumInfo.jKMUserProCnt);
                    setJKMUserFansCnt(sumInfo.jKMUserFansCnt);
                }

                const res = await getWebUserSchedule();
                if (res.code === 200 && res.data.length > 0) {
                    const fansInfo = res.data.map(item => ({
                        user_name: item.user_name,
                        fansCount: item.fan_cnt,
                        user_id: item.user_id,
                        update_at: item.update_at,
                        max_schedule_date: item.max_schedule_date,
                    }));
                    setInfoList(fansInfo);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getInfos();
    }, []);

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
    };

    const filteredList = infoList.filter(item => {
        const conds = [
            (item.user_name?.toString() ?? '').includes(filterUserName),
            (item.user_id?.toString() ?? '').includes(filterUserId),
            (item.update_at?.toString() ?? '').includes(filterUpdateAt),
            (item.max_schedule_date?.toString() ?? '').includes(filterMaxScheduleDate),
        ];
        return searchMode === 'and' ? conds.every(Boolean) : conds.some(Boolean);
    });

    const sortedList = sortColumn
        ? [...filteredList].sort((a, b) => {
            const valA = a[sortColumn];
            const valB = b[sortColumn];
            if (valA == null || valB == null) return 0;

            if (typeof valA === 'number' && typeof valB === 'number') {
                return sortDirection === 'asc' ? valA - valB : valB - valA;
            }

            return sortDirection === 'asc'
                ? valA.toString().localeCompare(valB.toString())
                : valB.toString().localeCompare(valA.toString());
        })
        : filteredList;

    const handleClear = () => {
        setFilterUserName('');
        setFilterUserId('');
        setFilterUpdateAt('');
        setFilterMaxScheduleDate('');
    };

    const exportToExcel = () => {
        const data = sortedList.map(item => ({
            "TwitterID": item.user_id,
            "プロ／ゲスト名": item.user_name,
            "ファン数": item.fansCount,
            "更新日": item.update_at,
            "最大スケジュール日": item.max_schedule_date,
        }));
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "FansCount");
        XLSX.writeFile(workbook, "FansCountList.xlsx");
    };

    const renderSortIcon = (column) => {
        if (sortColumn !== column) return '';
        return sortDirection === 'asc' ? ' ▲' : ' ▼';
    };

    return (
        <MainLayout>
            <div style={{ marginBottom: '10px', textAlign: 'left', color: '#008000' }}>
                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    ファン-アプリの利用状況
                </span>
            </div>

            <TableSum>
                <thead>
                    <tr>
                        <TableHeaderSum>推しごとカレンダー利用者数↓</TableHeaderSum>
                        <TableHeaderSumForJM>雀活マスター利用プロ数↓</TableHeaderSumForJM>
                        <TableHeaderSumForJM>雀活マスター利用ファン数↓</TableHeaderSumForJM>
                    </tr>
                </thead>
                <tbody>
                    <TableRow>
                        <TitleCell>{oshicalUserCnt}</TitleCell>
                        <TitleCell>{jKMUserProCnt}</TitleCell>
                        <TitleCell>{jKMUserFansCnt}</TitleCell>
                    </TableRow>
                </tbody>
            </TableSum>

            {/* フィルターエリア */}
            <div style={{ marginBottom: '10px', textAlign: 'left', color: '#666', fontStyle: 'italic' }}>
                <span style={{ fontSize: '13px' }}>絞り込み条件</span>
            </div>

            <div style={{ marginBottom: '10px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                <input type="text" placeholder="プロ／ゲスト名" value={filterUserName} onChange={(e) => setFilterUserName(e.target.value)} />
                <input type="text" placeholder="TwitterID" value={filterUserId} onChange={(e) => setFilterUserId(e.target.value)} />
                <input type="text" placeholder="更新日" value={filterUpdateAt} onChange={(e) => setFilterUpdateAt(e.target.value)} />
                <input type="text" placeholder="最大スケジュール日" value={filterMaxScheduleDate} onChange={(e) => setFilterMaxScheduleDate(e.target.value)} />
                <button onClick={handleClear}>クリア</button>
                <button onClick={exportToExcel}>Excel出力</button>
            </div>

            <div style={{ marginBottom: '10px' }}>
                <label>
                    <input type="radio" value="and" checked={searchMode === 'and'} onChange={() => setSearchMode('and')} />
                    AND検索
                </label>
                <label style={{ marginLeft: '10px' }}>
                    <input type="radio" value="or" checked={searchMode === 'or'} onChange={() => setSearchMode('or')} />
                    OR検索
                </label>
            </div>

            <div style={{ marginBottom: '5px', textAlign: 'left', color: '#666', fontStyle: 'italic' }}>
                <span style={{ fontSize: '13px' }}>
                    📊 全データ：{infoList.length} 件 ／ フィルター結果：{filteredList.length} 件
                </span>
            </div>

            <Table>
                <thead>
                    <tr>
                        <TableHeader onClick={() => handleSort('user_id')}>TwitterID{renderSortIcon('user_id')}</TableHeader>
                        <TableHeader onClick={() => handleSort('user_name')}>プロ／ゲスト名{renderSortIcon('user_name')}</TableHeader>
                        <TableHeader onClick={() => handleSort('fansCount')}>ファン数{renderSortIcon('fansCount')}</TableHeader>
                        <TableHeader onClick={() => handleSort('update_at')}>更新日{renderSortIcon('update_at')}</TableHeader>
                        <TableHeader onClick={() => handleSort('max_schedule_date')}>最大スケジュール日{renderSortIcon('max_schedule_date')}</TableHeader>
                    </tr>
                </thead>
                <tbody>
                    {sortedList.map((item, index) => (
                        <TableRow key={index}>
                            <TitleCell>{item.user_id}</TitleCell>
                            <TitleCell>{item.user_name}</TitleCell>
                            <TitleCell>{item.fansCount}</TitleCell>
                            <TitleCell>{item.update_at}</TitleCell>
                            <TitleCell>{item.max_schedule_date}</TitleCell>
                        </TableRow>
                    ))}
                </tbody>
            </Table>
        </MainLayout>
    );
}

export default FansCount;
